import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useAtomValue } from 'jotai';
import useAPI from '../../../api';
import { userDataAtom, selectedBranchAtom } from '../../../Atoms';
import useModuleFlag from '../../../Hooks/useModuleFlag';

/**
 * State behind ScheduleFields: the picked date and time slot, written to the form's `scheduledOn`,
 * and the users the activity can be assigned to. Call it from the form itself, not from the fields.
 */
const useScheduleFields = function useScheduleFields(isOperator) {
  const API = useAPI();
  const { setValue } = useFormContext();

  const userData = useAtomValue(userDataAtom);
  // Whether this installation lets an operator be named as the assignee.
  const canAssignAppointee = useModuleFlag('APPOINTMENT_ASSIGNEE_FEATURE');
  const selectedBranch = useAtomValue(selectedBranchAtom);

  const [timeSlot, setTimeSlot] = useState('');
  const [date, setDate] = useState(new Date());
  const [operators, setOperators] = useState([]);

  useEffect(() => {
    const self = [
      {
        label: `${userData?.name} ${userData?.surname}`,
        value: userData?.id,
      },
    ];
    if (!isOperator && selectedBranch) {
      API.getBranchUsersByRole(
        selectedBranch.id,
        ['OPERATOR', 'SUPERVISOR'],
        (result) => {
          if (result && result.length > 0)
            setOperators(
              result.map(({ id, name, surname }) => ({
                label: `${name} ${surname}`,
                value: id,
              }))
            );
          else setOperators(self);
        },
        () => {
          setOperators(self);
        }
      );
    } else {
      // Without a branch's users to pick from: the user alone when they may assign appointees, else nobody.
      setOperators(canAssignAppointee ? self : []);
    }
  }, [isOperator]);

  useEffect(() => {
    if (timeSlot) {
      const scheduledDate = new Date(date);
      scheduledDate.setHours(
        parseInt(timeSlot.substring(0, 2), 10),
        parseInt(timeSlot.substring(3, 5), 10)
      );
      setValue('scheduledOn', scheduledDate);
    }
  }, [timeSlot, date]);

  return { date, setDate, timeSlot, setTimeSlot, operators };
};

export default useScheduleFields;
